import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

export function Loading() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-muted p-10">
      <Link to="/">
        <img alt="Logo" src="/images/Logo-Lockup-Black.svg" className="h-8" />
      </Link>
      <Card className="w-full max-w-[384px]">
        <CardContent className="pt-6">
          <div className="flex flex-col items-center gap-4">
            <p className="text-sm text-muted-foreground">Authentication initializing...</p>
            <div className="h-1 w-full overflow-hidden rounded-full bg-secondary">
              <div className="h-full w-1/3 animate-pulse rounded-full bg-primary" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
